export type MealOptionRow = {
  selectOption?: unknown;
  positionName?: string;
  contractorName?: string;
  startDate?: string;
  isDeleted?: boolean;
  isPositionDeleted?: boolean;
  firstBreak?: unknown;
  afterFirstBreakIn?: unknown;
  secondBreak?: unknown;
  afterSecondBreakIn?: unknown;
  contractorFirstBreak?: unknown;
  contractorAfterFirstBreakIn?: unknown;
  contractorSecondBreak?: unknown;
  contractorAfterSecondBreakIn?: unknown;
  contractor_firstBreak?: unknown;
  contractor_afterFirstBreakIn?: unknown;
  contractor_secondBreak?: unknown;
  contractor_afterSecondBreakIn?: unknown;
};

/** Advisory only. Never changes the selected meal option, hours or money. */
export function hasMealOption(value: unknown): boolean {
  if (typeof value !== "string") return false;
  const option = value.toLowerCase();
  return option === "meal provided" || option === "1 hour walk away";
}

const filled = (value: unknown) =>
  value !== null && value !== undefined && value !== "" && value !== "TBD" &&
  value !== "Invalid DateTime";

export function hasRecordedMealBreak(row: MealOptionRow): boolean {
  return [
    [row.firstBreak, row.afterFirstBreakIn],
    [row.secondBreak, row.afterSecondBreakIn],
    [row.contractorFirstBreak, row.contractorAfterFirstBreakIn],
    [row.contractorSecondBreak, row.contractorAfterSecondBreakIn],
    [row.contractor_firstBreak, row.contractor_afterFirstBreakIn],
    [row.contractor_secondBreak, row.contractor_afterSecondBreakIn],
  ].some(([start, end]) => filled(start) && filled(end));
}

export function rowsMissingMealOption(
  rows: MealOptionRow[] | null | undefined,
  recordedBreakOnly = false,
): MealOptionRow[] {
  return (Array.isArray(rows) ? rows : []).filter((row) =>
    row && row.isDeleted !== true && row.isPositionDeleted !== true &&
    !hasMealOption(row.selectOption) && (!recordedBreakOnly || hasRecordedMealBreak(row)),
  );
}

export function mealOptionRowLabels(rows: MealOptionRow[]): string[] {
  return [...new Set(rows.map((row) => [
    row.contractorName,
    row.positionName,
    row.startDate?.slice(0, 10),
  ].filter(Boolean).join(" · ")).filter(Boolean))];
}
